// Action constants
import {SET} from './constants';

const DEFAULT_STATE = {
  visible: false,
  vehicle: null,
};

export default (state = DEFAULT_STATE, {type, data}) => {
  switch (type) {
    case SET: {
      return {
        ...state,
        ...data,
      };
    }

    default: {
      return state;
    }
  }
};
